export default "__VITE_ASSET__0af64d2a__"